var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, ginni } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { DataGrid } from '../elements/data-grid';
import { DataGridCell } from '../elements/data-grid-cell';
import { DataGridRow } from '../elements/data-grid-row';
import { DataGridHeadCell } from '../elements/data-grid-head-cell';
import { MarkdownContent } from '../elements/markdown-content';
import { useLang } from '../hooks/use-lang';
import { compact, keyBy, map, omit, reduce } from 'lodash';
import { useManagement } from '../hooks/use-management';
import { EntityTypeSelect } from '../select/entity-type-select';
import { useClickOutside } from '../hooks/use-click-outside';
import { BinIconGlyph, MoveToEndIconGlyph, MoveToStartIconGlyph, PlusIconGlyph, RequiredIconGlyph } from '@shapeable/icons';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { closestCenter, DndContext, DragOverlay, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { useDndDialogModifier } from '../select/hooks/use-dnd-dialog-modifier';
import { entityFieldIsEmpty } from '../utils/entity-field-is-empty';
import { useFormFieldComponents } from '../hooks/use-form-field-components';
import { useFieldCellComponents } from '../hooks/use-field-cell-components';
import { FormFieldHidden } from '../elements/form-field-hidden';
import { FieldCellDefault } from '../elements/field-cell-default';
import { isNewRow } from '../select/utils/is-new-row';
import { entityFieldIsValid } from '../utils/entity-field-is-valid';
import { Icon } from '../elements/icon';
import { entityFieldMutationValue } from '../utils/entity-field-mutation-value';
var cls = classNames('entity-data-grid');
export var EntityDataGridDefaultProps = {
  items: [],
  showFoot: true,
  isSortable: true,
  isReadOnly: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-height: 60vh;\n    border-top: 1px solid ", "; \n\n    /* Ensure that selects don't get too squished */\n    .shp--cell-label {\n      white-space: nowrap;\n    }\n\n    .shp--entity-value__name {\n      white-space: nowrap;\n    }\n    \n  "], ["\n    max-height: 60vh;\n    border-top: 1px solid ", "; \n\n    /* Ensure that selects don't get too squished */\n    .shp--cell-label {\n      white-space: nowrap;\n    }\n\n    .shp--entity-value__name {\n      white-space: nowrap;\n    }\n    \n  "])), theme.COLOR('very-subtle'))
});
var CellStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 0;\n    ", "\n\n    /* ", " */\n\n\n  "], ["\n    padding: 0;\n    ", "\n\n    /* ", " */\n\n\n  "])), function (_a) {
    var hasPadding = _a.hasPadding;
    return hasPadding && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      /* TODO = make this more robust, with cells determining their own padding etc */\n      padding: 8px 14px;\n    "], ["\n      /* TODO = make this more robust, with cells determining their own padding etc */\n      padding: 8px 14px;\n    "])));
  }, function (_a) {
    var isDirty = _a.isDirty,
      isEditing = _a.isEditing;
    return isDirty && !isEditing && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding-bottom: 14px;\n    "], ["\n      padding-bottom: 14px;\n    "])));
  })
});
var SelectStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-family: ", ";\n  "], ["\n    font-family: ", ";\n  "])), theme.FONT('app'))
});
var RowStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    &:last-child {\n      border-bottom: none;\n    }\n  "])))
});
var TooltipContentStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FootContentStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    user-select: none;\n    display: flex;\n    padding-left: 2px;\n    padding: 10px 14px 12px 14px;\n    font-weight: 500;\n    color: inherit;\n    align-items: center;\n  "], ["\n    user-select: none;\n    display: flex;\n    padding-left: 2px;\n    padding: 10px 14px 12px 14px;\n    font-weight: 500;\n    color: inherit;\n    align-items: center;\n  "])))
});
var CellIndicatorStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n   position: absolute;\n    right: 4px;\n    top: 4px;\n    background: ", ";\n    border-radius: 4px;\n    box-shadow: 0 0 5px 1px ", ";\n    line-height: 8px;\n    padding: 6px 6px;\n    cursor: default;\n  "], ["\n   position: absolute;\n    right: 4px;\n    top: 4px;\n    background: ", ";\n    border-radius: 4px;\n    box-shadow: 0 0 5px 1px ", ";\n    line-height: 8px;\n    padding: 6px 6px;\n    cursor: default;\n  "])), theme.COLOR('very-subtle-chrome-updated'), theme.COLOR('very-subtle-chrome-updated'))
});
var CellIconStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    cursor: default;\n  "], ["\n    cursor: default;\n  "])))
});
var FootGutterButtonStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    user-select: none;\n    display: flex;\n    padding-left: 2px;\n    padding: 10px 14px 12px 14px;\n    font-weight: 500;\n    color: inherit;\n    align-items: center;\n    cursor: pointer;\n    &:hover {\n      background-color: ", ";\n    }\n  "], ["\n    user-select: none;\n    display: flex;\n    padding-left: 2px;\n    padding: 10px 14px 12px 14px;\n    font-weight: 500;\n    color: inherit;\n    align-items: center;\n    cursor: pointer;\n    &:hover {\n      background-color: ", ";\n    }\n  "])), theme.COLOR('very-subtle-chrome'))
});
var OverlayGridStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    opacity: 0.3;\n    background: ", ";\n    border-top: 1px solid ", ";\n    border-left: 1px solid ", ";\n    border-right: 1px solid ", ";\n  "], ["\n    opacity: 0.3;\n    background: ", ";\n    border-top: 1px solid ", ";\n    border-left: 1px solid ", ";\n    border-right: 1px solid ", ";\n  "])), theme.COLOR('canvas'), theme.COLOR('line-subtle'), theme.COLOR('line-subtle'), theme.COLOR('line-subtle'))
});
var EmptyContentStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ComfortRowStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    cursor: pointer;\n  "], ["\n    cursor: pointer;\n  "])))
});
var ComfortCellStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    cursor: pointer;\n    height: 100px;\n    border-bottom: none;\n  "], ["\n    cursor: pointer;\n    height: 100px;\n    border-bottom: none;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'EntityDataGrid',
  Container: styled(DataGrid)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  OverlayGrid: styled.table(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), OverlayGridStyles),
  /* Wrapper to Produce a Single-Row table for a DnD Drag Overlay */
  Row: styled(DataGridRow)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  Cell: styled(DataGridCell)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), CellStyles),
  Select: styled(EntityTypeSelect)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  HeadCell: styled(DataGridHeadCell)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), CellStyles),
  EmptyContent: styled.span(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), EmptyContentStyles),
  TooltipContent: styled(MarkdownContent)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), TooltipContentStyles),
  FootContent: styled.span(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), FootContentStyles),
  FootGutterButton: styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), FootGutterButtonStyles),
  RequiredIndicator: styled(Icon)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), CellIndicatorStyles),
  RequiredIcon: styled(RequiredIconGlyph)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), CellIconStyles),
  ComfortRow: styled(DataGridRow)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), ComfortRowStyles),
  ComfortCell: styled(DataGridCell)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), ComfortCellStyles)
};
export var EntityDataGrid = function (props) {
  var componentProps = useComponentProps(My.NAME, EntityDataGridDefaultProps, props);
  var className = componentProps.className,
    items = componentProps.items,
    defn = componentProps.defn,
    showFoot = componentProps.showFoot,
    showBorder = componentProps.showBorder,
    isReadOnly = componentProps.isReadOnly,
    onInsertRow = componentProps.onInsertRow,
    onDeleteRow = componentProps.onDeleteRow,
    onChange = componentProps.onChange,
    colors = componentProps.colors;
  var _a = __read(React.useState(), 2),
    editCell = _a[0],
    setEditCell = _a[1];
  var _b = __read(React.useState([]), 2),
    selectedCells = _b[0],
    setSelectedCells = _b[1];
  var _c = __read(React.useState({}), 2),
    mutatedRows = _c[0],
    setMutatedRows = _c[1];
  // const [ trashedRows, setTrashedRows ] = React.useState<CellData>({});
  var _d = __read(React.useState([]), 2),
    deletedRows = _d[0],
    setDeletedRows = _d[1];
  var _e = __read(React.useState(map(defn.formFields, function (field) {
      return 0;
    })), 2),
    columnWidths = _e[0],
    setColumnWidths = _e[1];
  var isSortable = isReadOnly ? false : !!componentProps.isSortable;
  var FormFieldComponents = useFormFieldComponents();
  var FieldCellComponents = useFieldCellComponents();
  var _f = __read(useState(null), 2),
    activeDragId = _f[0],
    setActiveDragId = _f[1];
  var _g = __read(useState(null), 2),
    activeDragItem = _g[0],
    setActiveDragItem = _g[1];
  // setup the row sequence, using the initial ordering of the items
  var _h = __read(React.useState([]), 2),
    rowSequence = _h[0],
    setRowSequence = _h[1];
  // setup a drag effect to map the active drag id to an actual selection item
  useEffect(function () {
    if (activeDragId) {
      var item = items.find(function (item) {
        return item.id === activeDragId;
      });
      setActiveDragItem(item);
    } else {
      setActiveDragItem(null);
    }
  }, [activeDragId, items]);
  var sensors = useSensors(useSensor(PointerSensor, {
    activationConstraint: {
      distance: 10
      // delay: 0, // ms delay before drag starts
      // tolerance: 15, // movement threshold in px before drag can start
    }
  }));
  var dataGridRef = useClickOutside(function () {
    setEditCell(null);
    setSelectedCells([]);
  }, []);
  ginni.verbose.log("EntityDataGrid column widths", columnWidths);
  // any time the items change, record the current set of column widths - this is used to make DragOverlay accurately
  // represent the current column widths
  useEffect(function () {
    var _a;
    if (dataGridRef === null || dataGridRef === void 0 ? void 0 : dataGridRef.current) {
      /* @ts-ignore */
      var firstRow = (_a = dataGridRef === null || dataGridRef === void 0 ? void 0 : dataGridRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("tbody tr:first-child");
      if (firstRow) {
        var cells = firstRow.querySelectorAll('td:not(.shp--data-grid-actions-cell)');
        if (!cells) {
          return;
        }
        var newColumnWidths = Array.from(cells).map(function (cell) {
          return cell.clientWidth;
        });
        ginni.verbose.log("EntityDataGrid - NEW COLUMN WIDTHS", newColumnWidths);
        setColumnWidths(newColumnWidths);
      }
    }
  }, [items]);
  // set the initial row sequence on mount
  useEffect(function () {
    var startingRowSequence = items.map(function (item) {
      return item.id;
    });
    // console.log("EntityDataGrid - Starting Row Sequence", startingRowSequence);
    setRowSequence(startingRowSequence);
    // return () => {
    // }
  }, []);
  var fieldDefns = keyBy(defn.formFields, 'name');
  // if we provide a change handler, assume this is a controlled grid
  var isControlled = !!onChange;
  var callbackDeps = [items, rowSequence, mutatedRows, deletedRows];
  ginni.verbose.log("EntityDataGrid - Items", items);
  ginni.verbose.log("EntityDataGrid - Row Sequence", rowSequence);
  ginni.verbose.log("EntityDataGrid - Mutated Rows", mutatedRows);
  ginni.verbose.log("EntityDataGrid - Deleted Rows", deletedRows);
  var insertRow = useCallback(function (args) {
    var _a;
    var _b;
    ginni.verbose.log("EntityDataGrid - Insert Row", callbackDeps);
    var newRowId = "_new_".concat(Date.now());
    var newRow = __assign(__assign({
      id: {
        value: newRowId,
        mutationValue: newRowId
      }
    }, reduce(defn.formFields, function (acc, field) {
      acc[field.name] = {
        value: null,
        mutationValue: null,
        isValid: entityFieldIsValid(null, field)
      };
      return acc;
    }, {})), (args === null || args === void 0 ? void 0 : args.data) || {});
    var newMutatedRows = __assign(__assign({}, mutatedRows), (_a = {}, _a[newRowId] = newRow, _a));
    setMutatedRows(newMutatedRows);
    var newRowSequence;
    if (args === null || args === void 0 ? void 0 : args.above) {
      var index = rowSequence.indexOf(args.above);
      if (index > -1) {
        newRowSequence = __spreadArray(__spreadArray(__spreadArray([], __read(rowSequence.slice(0, index)), false), [newRowId], false), __read(rowSequence.slice(index)), false);
      }
    } else if (args === null || args === void 0 ? void 0 : args.below) {
      var index = rowSequence.indexOf(args.below);
      if (index > -1) {
        newRowSequence = __spreadArray(__spreadArray(__spreadArray([], __read(rowSequence.slice(0, index + 1)), false), [newRowId], false), __read(rowSequence.slice(index + 1)), false);
      }
    } else {
      newRowSequence = __spreadArray(__spreadArray([], __read(rowSequence), false), [newRowId], false);
    }
    setRowSequence(newRowSequence);
    if (onInsertRow) {
      onInsertRow({
        row: newRowId,
        value: newRow,
        mutationValue: newRowId,
        rowSequence: newRowSequence
      });
    }
    if (!(args === null || args === void 0 ? void 0 : args.above) && !(args === null || args === void 0 ? void 0 : args.below)) {
      /* @ts-ignore */
      (_b = dataGridRef.current) === null || _b === void 0 ? void 0 : _b.scrollTo({
        top: dataGridRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }
    // TODO - think about if this is really the right approach. the items likely need to be recomputed every time
    // regardless of if we are controlled or not, it's more about bubbling up the change 
    if (!isControlled) {
      console.log("EntityDataGrid - Insert Row - No Change Handler");
      return;
    }
    // if we are controlled, we need to compute the new items
    var itemsById = keyBy(items, 'id');
    // map over the row sequence
    // this will check to see if the row is first in the provided items
    // and if not, check if it is the inserted row ID.
    // this allows us to insert the new row in the correct place which may be in the middle of the list
    var newItems = newRowSequence.reduce(function (acc, rowId) {
      var item = itemsById[rowId];
      if (item) {
        acc.push(item);
      }
      if (rowId === newRowId) {
        var newItem = __assign({
          id: newRowId,
          __typename: defn.name
        }, reduce(defn.formFields, function (acc, field) {
          var _a;
          acc[field.name] = ((_a = args === null || args === void 0 ? void 0 : args.data) === null || _a === void 0 ? void 0 : _a[field.name].value) || null;
          return acc;
        }, {}));
        acc.push(newItem);
      }
      return acc;
    }, []);
    onChange({
      items: newItems,
      mutatedRows: newMutatedRows,
      deletedRows: deletedRows,
      rowSequence: newRowSequence
    });
  }, callbackDeps);
  // -------------------- DELETE ROW -------------------->
  var deleteRow = useCallback(function (rowId) {
    var itemsById = keyBy(items, 'id');
    var newRowSequence = rowSequence.filter(function (id) {
      return id !== rowId;
    });
    var newDeletedRows = itemsById[rowId] && !isNewRow(rowId) ? __spreadArray(__spreadArray([], __read(deletedRows), false), [rowId], false) : deletedRows;
    // const newDeletedRows: CellData = {
    //   ...deletedRows,
    //   // rowId
    //   // [rowId]: mutatedRows[rowId],
    // };
    var deletedRow = mutatedRows[rowId];
    var newMutatedRows = omit(mutatedRows, rowId);
    setMutatedRows(newMutatedRows);
    setRowSequence(newRowSequence);
    setDeletedRows(newDeletedRows);
    ginni.verbose.log("EntityDataGrid - Delete Row - New Row Sequence", newRowSequence);
    ginni.verbose.log("EntityDataGrid - Delete Row - New Deleted Rows", newDeletedRows);
    ginni.verbose.log("EntityDataGrid - Delete Row - Deleted Row", deletedRow);
    ginni.verbose.log("EntityDataGrid - Delete Row - New Mutated Rows", newMutatedRows);
    if (onDeleteRow) {
      onDeleteRow({
        row: rowId,
        value: deletedRow,
        mutationValue: rowId,
        rowSequence: newRowSequence
      });
    }
    if (!isControlled) {
      return;
    }
    // map over the row sequence
    // this will check to see if the row is first in the provided items
    // and if not, check if it is the inserted row ID.
    // this allows us to insert the new row in the correct place which may be in the middle of the list
    var newItems = newRowSequence.reduce(function (acc, rowSequenceId) {
      var item = itemsById[rowSequenceId];
      if (item && item.id !== rowId) {
        acc.push(item);
      }
      return acc;
    }, []);
    onChange({
      items: newItems,
      mutatedRows: newMutatedRows,
      deletedRows: newDeletedRows,
      rowSequence: newRowSequence
    });
  }, callbackDeps);
  // -------------------- MOVE TO END -------------------->
  var moveToEnd = useCallback(function (rowId) {
    var newRowSequence = rowSequence.filter(function (id) {
      return id !== rowId;
    });
    newRowSequence.push(rowId);
    setRowSequence(newRowSequence);
    var itemsById = keyBy(items, 'id');
    var newItems = newRowSequence.reduce(function (acc, rowId) {
      var item = itemsById[rowId];
      if (item) {
        acc.push(item);
      }
      return acc;
    }, []);
    onChange({
      items: newItems,
      mutatedRows: mutatedRows,
      deletedRows: deletedRows,
      rowSequence: newRowSequence
    });
  }, callbackDeps);
  // -------------------- MOVE TO START -------------------- >
  var moveToStart = useCallback(function (rowId) {
    var newRowSequence = rowSequence.filter(function (id) {
      return id !== rowId;
    });
    newRowSequence.unshift(rowId);
    setRowSequence(newRowSequence);
    var itemsById = keyBy(items, 'id');
    var newItems = newRowSequence.reduce(function (acc, rowId) {
      var item = itemsById[rowId];
      if (item) {
        acc.push(item);
      }
      return acc;
    }, []);
    onChange({
      items: newItems,
      mutatedRows: mutatedRows,
      deletedRows: deletedRows,
      rowSequence: newRowSequence
    });
  }, callbackDeps);
  // -------------------- UPDATE CELL -------------------- >
  var updateCell = function (_a) {
    // TODO - throttle these changes so that controls can remain a little more responsive
    var _b, _c;
    var row = _a.row,
      field = _a.field,
      value = _a.value,
      mutationValue = _a.mutationValue;
    var newMutatedRows = __assign(__assign({}, mutatedRows), (_b = {}, _b[row] = __assign(__assign({}, mutatedRows[row] || {}), (_c = {}, _c[field] = {
      value: value,
      mutationValue: mutationValue,
      isValid: entityFieldIsValid(value, fieldDefns[field])
    }, _c)), _b));
    setMutatedRows(newMutatedRows);
    if (!isControlled) {
      /*
      No change handler, so just return.
      NB: This could be an important optimization - in the case of a large grid
      that is not part of a form, we probably don't need to compute the entire new value.
      But in the case of a form, we want to bubble up the entire new value to th form field which
      the grid represents, in a way that is similar to how any other form field would work.
      */
      return;
    }
    // compute the new set of items
    var itemsById = keyBy(items, 'id');
    // take care to maintain order of items
    var newItems = rowSequence.reduce(function (acc, rowId) {
      var _a;
      var item = itemsById[rowId];
      if (item) {
        if (rowId === row) {
          var newItem = __assign(__assign({}, item), (_a = {}, _a[field] = value, _a));
          acc.push(newItem);
        } else {
          acc.push(item);
        }
      }
      return acc;
    }, []);
    onChange({
      items: newItems,
      mutatedRows: newMutatedRows,
      deletedRows: deletedRows,
      rowSequence: rowSequence
    });
  };
  // ---------- ROW MENU ---------->
  var handleRowMenuItemSelect = function (row) {
    return function (args) {
      // so, here we have the selection this applies to, and the menu item that was selected inside the grip button for that selection
      if (args.item.id === 'remove') {
        deleteRow(row);
      }
      if (args.item.id === 'move-to-start') {
        moveToStart(row);
      }
      if (args.item.id === 'move-to-end') {
        moveToEnd(row);
      }
      if (args.item.id === 'insert-above') {
        insertRow({
          above: row
        });
      }
      if (args.item.id === 'insert-below') {
        insertRow({
          below: row
        });
      }
      if (args.item.id === 'duplicate') {
        var item_1 = items.find(function (item) {
          return item.id === row;
        });
        if (item_1) {
          var data = __assign({}, reduce(defn.formFields, function (acc, field) {
            acc[field.name] = {
              value: item_1[field.name],
              mutationValue: entityFieldMutationValue(item_1[field.name], field)
            };
            return acc;
          }, {}));
          insertRow({
            below: row,
            data: data
          });
        }
      }
    };
  };
  var getCellKey = function (row, field) {
    return "".concat(row, "_").concat(field);
  };
  var handleCellClick = function (args) {
    return function (event) {
      var cellKey = args.cellKey,
        rowItem = args.rowItem,
        isEditing = args.isEditing,
        isEmpty = args.isEmpty;
      setSelectedCells([cellKey]);
      if (!isReadOnly) {
        if (!isEditing) {
          setEditCell(cellKey);
        }
      }
    };
  };
  var handleCellChange = function (args) {
    updateCell(args);
  };
  var handleAddClick = function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (isReadOnly) {
      return;
    }
    insertRow();
  };
  var handleComfortCellClick = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (isReadOnly) {
      return;
    }
    insertRow();
  }, callbackDeps);
  var handleFormFieldChange = function (_a) {
    var fieldName = _a.fieldName,
      rowId = _a.rowId;
    return function (_a) {
      var value = _a.value,
        mutationValue = _a.mutationValue;
      handleCellChange({
        row: rowId,
        field: fieldName,
        value: value,
        mutationValue: mutationValue
      });
    };
  };
  var handleRowDragStart = function (event) {
    setActiveDragId(event.active.id);
  };
  var handleRowDragEnd = useCallback(function (event) {
    var active = event.active,
      over = event.over;
    ginni.verbose.log("EntityDataGrid - Drag End", active.id, over.id, rowSequence);
    if (!over || active.id === over.id) {
      setActiveDragId(null);
      return;
    }
    var oldIndex = rowSequence.indexOf(active.id);
    var newIndex = rowSequence.indexOf(over.id);
    var newRowSequence = __spreadArray([], __read(rowSequence), false);
    newRowSequence.splice(newIndex, 0, newRowSequence.splice(oldIndex, 1)[0]);
    setRowSequence(newRowSequence);
    var itemsById = keyBy(items, 'id');
    ginni.verbose.log("EntityDataGrid - Drag End - New Row Sequence", newRowSequence);
    var newItems = newRowSequence.reduce(function (acc, rowId) {
      var item = itemsById[rowId];
      if (item) {
        acc.push(item);
      }
      return acc;
    }, []);
    onChange({
      items: newItems,
      deletedRows: deletedRows,
      mutatedRows: mutatedRows,
      rowSequence: newRowSequence
    });
    setActiveDragId(null);
  }, callbackDeps);
  var modifiers = useDndDialogModifier({
    ref: dataGridRef
  });
  var manage = useManagement();
  var t = useLang();
  // ginni.verbose.log("UPDATED CELLS", updatedRows);
  var rowElement = function (row, rowIndex, isSortable, isOverlay) {
    var rowValue = row;
    var rowMenu = {
      id: 'selection-menu',
      width: 180,
      sections: [{
        id: 'manage',
        name: 'Manage'
      }, {
        id: 'move',
        name: 'Move'
      }, {
        id: 'insert',
        name: 'Insert'
      }],
      items: compact([!isReadOnly && {
        id: 'remove',
        label: 'Remove',
        iconComponent: BinIconGlyph,
        section: 'manage'
      }, !isReadOnly && {
        id: 'duplicate',
        label: 'Duplicate',
        iconComponent: PlusIconGlyph,
        section: 'manage'
      }, isSortable && {
        id: 'move-to-start',
        label: 'Move To Start',
        iconComponent: MoveToStartIconGlyph,
        section: 'move',
        isDisabled: rowIndex === 0
      }, isSortable && {
        id: 'insert-above',
        label: 'Insert Row Above',
        iconComponent: PlusIconGlyph,
        section: 'insert'
      }, isSortable && {
        id: 'insert-below',
        label: 'Insert Row Below',
        iconComponent: PlusIconGlyph,
        section: 'insert'
      }, isSortable && {
        id: 'move-to-end',
        label: 'Move To End',
        iconComponent: MoveToEndIconGlyph,
        section: 'move',
        isDisabled: rowIndex === items.length - 1
      }])
    };
    var isAdded = isNewRow(row.id);
    return React.createElement(My.Row, {
      isAdded: isAdded,
      isUpdated: !isAdded && !!mutatedRows[row.id],
      id: row.id,
      menu: rowMenu,
      menuProps: {
        noMatchesText: t('No actions available')
      },
      key: rowIndex,
      isSortable: isSortable,
      onMenuItemSelect: handleRowMenuItemSelect(row.id)
    }, defn.formFields.map(function (field, colIndex) {
      var _a;
      // need a more reliable empty check
      var isDirty = !!(mutatedRows[row.id] && ((_a = mutatedRows[row.id][field.name]) === null || _a === void 0 ? void 0 : _a.value));
      var FormFieldComponent = FormFieldComponents[field.formFieldType] || FormFieldHidden;
      var FieldCellComponent = FieldCellComponents[field.type] || FieldCellDefault;
      var cellKey = getCellKey(row.id, field.name);
      var emptyContent = React.createElement(My.EmptyContent, null, field.required && React.createElement(My.RequiredIndicator, {
        color: "red",
        id: "required-icon-".concat(cellKey),
        tooltip: t('This field is required')
      }, React.createElement(My.RequiredIcon, {
        size: 10
      })));
      var fieldValue = rowValue[field.name];
      var isEmpty = entityFieldIsEmpty(fieldValue, field);
      var isEditing = editCell === cellKey;
      var isSelected = selectedCells.includes(cellKey);
      var fieldDefn = fieldDefns[field.name];
      var cellColors = {};
      if (isDirty && !(isAdded && isEmpty)) {
        cellColors.background = 'very-subtle-chrome-update';
      }
      // todo - make this contextual like the form field component
      var cellStyle = {};
      if (fieldDefn.formFieldType === 'longText') {
        cellStyle.minWidth = '420px';
        cellStyle.fontSize = '14px';
        cellStyle.lineHeight = '21px';
      }
      if (fieldDefn.formFieldType === 'linkedMultiple' || fieldDefn.formFieldType === 'linked') {
        cellStyle.minWidth = '260px';
      }
      // pull from the column widths if we are in an overlay
      // this is used to make the drag overlay match the grid
      if (isOverlay && columnWidths[colIndex]) {
        cellStyle.width = "".concat(columnWidths[colIndex], "px");
      }
      var formFieldName = "".concat(row.id, "-").concat(field.name);
      return React.createElement(My.Cell, {
        isDirty: isDirty,
        isReadOnly: isReadOnly,
        isEditing: isEditing,
        isSelected: isSelected,
        hasPadding: !isEditing,
        onClick: handleCellClick({
          isEmpty: isEmpty,
          cellKey: cellKey,
          rowItem: row,
          isEditing: isEditing
        }),
        colors: cellColors,
        style: cellStyle,
        isLastRow: rowIndex === items.length - 1,
        isLast: colIndex === defn.formFields.length - 1,
        key: colIndex
      }, isEditing ? ( /* Editing: use form fields, with "grid" target */
      React.createElement(FormFieldComponent, {
        onChange: handleFormFieldChange({
          fieldName: field.name,
          rowId: row.id
        }),
        name: formFieldName,
        target: 'grid',
        value: fieldValue,
        entityTypeName: field.entityTypeName,
        entityTypeDefinition: fieldDefn.entityTypeDefinition
      })) : ( /* Viewing: use field cell components with "grid" target */
      isEmpty ? emptyContent : React.createElement(React.Fragment, null, React.createElement(FieldCellComponent, {
        field: field,
        value: fieldValue,
        target: 'grid',
        colors: cellColors
      }))));
    }));
  };
  var activeDragItemElement = activeDragItem ? React.createElement(My.OverlayGrid, {
    cellSpacing: 0
  }, rowElement(activeDragItem, 0, true, true)) : null;
  return React.createElement(My.Container, {
    ref: dataGridRef,
    showBorder: showBorder,
    className: cls.name(className),
    head: defn.formFields.map(function (field, index) {
      var description = manage.isOwn ? field.ownDescription || field.description : field.description;
      return React.createElement(My.HeadCell, {
        isLast: index === defn.formFields.length - 1,
        id: field.name,
        key: index,
        tooltip: description && React.createElement(My.TooltipContent, {
          text: description
        })
      }, field.label);
    }),
    footOnClick: handleAddClick,
    footColSpan: defn.formFields.length + 1,
    foot: !isReadOnly && showFoot && React.createElement(My.FootContent, {
      onClick: handleAddClick
    }, t(items.length ? "".concat(defn.createAnotherLabel || 'Add More', " ...") : "".concat(defn.createLabel || 'Add', " ..."))),
    footGutterContent: React.createElement(My.FootGutterButton, null, React.createElement(PlusIconGlyph, {
      size: 16,
      colors: {
        fill: 'strong-chrome'
      }
    }))
  }, isSortable ? React.createElement(DndContext, {
    sensors: sensors,
    collisionDetection: closestCenter,
    onDragEnd: handleRowDragEnd,
    onDragStart: handleRowDragStart
  }, React.createElement(DragOverlay, {
    modifiers: modifiers
  }, activeDragItemElement), React.createElement(SortableContext, {
    items: rowSequence,
    strategy: verticalListSortingStrategy
  }, items.map(function (row, rowIndex) {
    return rowElement(row, rowIndex, isSortable, false);
  }))) : items.map(function (row, rowIndex) {
    return rowElement(row, rowIndex, false, false);
  }), !isReadOnly && React.createElement(My.ComfortRow, {
    isLast: true,
    id: 'comfort-row',
    onActionsClick: handleComfortCellClick,
    actions: React.createElement("div", null)
  }, defn.formFields.map(function (field, index) {
    return React.createElement(My.ComfortCell, {
      isEditing: false,
      onClick: handleComfortCellClick,
      showHoverState: false,
      isLast: index === defn.formFields.length - 1,
      key: index
    });
  })));
};
EntityDataGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29;